<template>
  <GridBase grey data-detail>
    <div class="inside top">
      <router-link class="btn-back" to="/archive/tech-talk">
        <Icon name="arrow-left"/>
        <em>Back to List</em>
      </router-link>
      <h1 v-html="info.title"/>
      <p class="info" v-if="info.techYmd">
        <span>TECH TALK</span><span class="date">{{ splitYmd(info.techYmd) }}</span>
        <a class="btn-share" v-if="false"/>
      </p>
    </div>
    <div class="inside body">
      <div v-html="info.content"></div>

      <ul class="tags">
        <li v-for="tag in info.tags" :key="tag"><s>{{ tag }}</s></li>
      </ul>

      <router-link class="btn-list" to="/archive/tech-talk">List</router-link>
    </div>
  </GridBase>
</template>

<script>
import _ from 'lodash';
import GridBase from "@/views/components/GridBase";
import Icon from "@/views/components/Icon";
// import kr from '@/data/archive/tech-talk';
// import en from '@/data/archive/tech-talk.en';

// const techData = { kr, en };

export default {
  name: 'DataTechDetail',
  components: {Icon, GridBase},
  data() {
    return {
      info: {}
    }
  },
  mounted() {
    this.oax.get(`/nosso/datacenter/tech/${this.$route.params.sq}`)
      .then(({ data }) => {
        data.data.category = 'tech';
        data.data.content = _.unescape(data.data.content);
        data.data.tags = data.data.techKeyword ? data.data.techKeyword.split(',') : []; 
        this.info = data.data;
      })
      .catch(this.handler());
  },
};
</script>

<style lang="less">
@import "~@/less/proj";
[data-detail] { .bgc(#FFF); color: #222; overflow: hidden;
  .inside{.mh-c; .w(100%); .-box; .p(0,20);
    &.top{.pt(30);
      .btn-back{.fs(20); .calibre; .medium; color:#222; .rel; .pl(43);
        em{.hide;}
        [icon]{.abs; .lt(0,-4);}
      }
      h1{.fs(38,52,-1); .mt(24); .mb(20); .extra-bold; .keep-all;
        .en & { .fs(42,48,0); .semi-bold; }
      }
      .info{ .rel;
        span{.fs(18); color:#424242; .ib; .medium; .calibre;
          &.date{ color: #424242; .rel; .ml(9); .pl(9);
            &:before{.cnt; .wh(2,13); .bgc(#757575); .abs; .lt(0,2);}
          }
        }
        .btn-share{.abs; .wh(20); .contain('@{img}/common/btn-share.svg');.r(0);}
      }
    }
    &.body{ .fs(14,24,-.5); .pt(40); .pb(80); color:#333;
      .en & { .fs(20,26,0); }
      b { .bold; .block;
        .en & { .medium; }
      }
      img{.max-w(100%); height:auto !important;}
      .exp{.fs(12); .lh(19); .ls(-.5); .mt(15); .mb(40); color:#616161;}
      .writer{.mt(40);}
      .tags{ .ib-list; .mt(60); .tc;
        li{.p(5,12); .fs(16); .bgc(#ecedf1); .calibre; .medium; .mb(12);
          &.on{color:white; .bgc(#0777ff);}
          &:not(:last-child) {.mr(8);}
          s { .cal-m; }
        }
      }
      .btn-list{.wh(100%,54); .-a(#878d96,1.4); .fs(20); color:#222; .bgc(white); .tc; .lh(58); .block; .mh-c; .mt(60); .calibre; .medium;}
    }
  }
  .kv{ .mt(30); .p(0,20);
    img { .max-w(100%); }
  }

  .news{ .bgc(#f7f8fb); .pt(100); .pb(120);
    h3{.calibre; .medium; .fs(34); color:#333; .tc; .mb(50);}
    [slider] { .mt(40); .p(0,5);
      .swiper-container{.w(100%); overflow: visible;}
      .swiper-slide { .rel; .pb(0); .w(335); .tl; .m(0,15);
        [card-image] { .cover; .bg-c; .h(201); }
        .date { .fs(18); .calibre; .medium; .mb(10);}
        .content { .-box; .rel; .p(20,20,0); .bgc(#fff);
          .txt { .fs(16,1.75); .ls(-0.5); .mt(10); .bold; color:#333333; overflow: hidden;}
          .title { .fs(24,1.5); .extra-bold; .max-h(72); .ellipsis(2); .ls(-1); .keep-all; }
          .duration { .fs(16); color: #bdbdbd; .mt(8); .calibre;
            s { .ib; .cal-m; .vam; }
            [icon] { .mr(4); }
          }
          .tags { .abs; .lb(0,10); .p(0,20);
            a { .fs(13); .lh(18); .p(2,5); .h(22); .-box; .-a(#e0e0e0); .br(2); .calibre; color:#757575; .gap-hr(6);
              s { .ib; .cal-m; }
            }
          }
        }
        .category { .p(12,20); .rel; .bgc(#fff);
          s { .fs(18); .calibre; .medium; .lh(24); .cal-m; .ib; }
          [icon] { .abs; .rt(20,12); }
        }

        &.img {
          .date { .abs; .lt(20,20); color: #fff; }
          .content{ .h(86);}
        }

        &.text{
          .content{.h(287);
            .title{ .h(100); .mb(84); .pr(45); }
            .txt{.max-h(112);}
          }
        }
      }
    }
  }

  @media (min-width: @screen-md-min) {
    .kv{ .mh-c; .w(346); .p(0); }
    .inside{.mh-c; .w(346); .p(0);
      &.body{ .pt(40); .pb(120);
      }
    }
  }

  @media (min-width: @screen-lg-min) {
    .kv{ .w(50%); }
    .inside{ .w(50%); .p(0,20); .-box;
      &.top{.pt(84);
        .btn-back{.fs(20); .medium; color:#222; .rel; .pl(43);
          em{ .cal-m; }
          [icon]{.abs; .lt(0,-4);}
        }
        h1{ .fs(48,64,-1.5); .mt(46); .mb(18);
          .en & { .fs(52,58,0); }
        }
        .info{ .mb(30);
          span{.fs(18); color:#424242; .ib;
            &.date{ color: #616161; .rel; .ml(10); .pl(10);
              &:before{.cnt; .wh(2,13); .bgc(#757575); .abs; .lt(0,3);}
            }
          }
          .btn-share{.wh(28); .t(-5);}
        }
      }
      &.body{ .fs(16, 26, -.5); .pb(120); color:#333;
        .en & { .fs(22,32, 0); }
        img { width: calc(100% + 40px); .mh(-20); }
        .exp{.fs(14); .lh(24); .ls(-.5); .vw-p(0,10); .mt(14); .mb(40); color:#616161;}
        .btn-list{.w(400);}
      }
    }
    .news{.p(100,0,120); .bgc(#f7f8fb);
      h3{.vw-fs(34); color:#333; .tc; .vw-mb(60);}
      [slider]{.vw-p(0,10);
        .swiper-slide{.vw-w(452); .tl; .vw-m(0,20);
          [card-image]{ .vw-h(272);}
          .content{ .vw-p(20,20,0,20);
            .title{.vw-fs(24); .vw-lh(36); .vw-ls(-1);}
            .txt{.max-h(140); overflow: hidden; .vw-fs(16); .vw-lh(28); .vw-ls(.5);}
          }
          &.img{
            .date { .vw-lt(20,20);}
            .content{.vw-h(92);
              .title{.vw-h(72); .vw-max-h(72);}
            }
          }
          &.text{
            .content{.vw-h(365);
              .title{ .vw-h(100); .vw-max-h(102); .vw-mb(84);  .vw-pr(240); }
              .txt{.vw-max-h(108);}
            }
          }
        }
      }
    }
  }
  @media (min-width: @screen-xxl-min) {
    .inside { .w(800); .p(0,40);
      &.top{
        h1{ .fs(60,80,-1); .mt(34); .mb(18);
          .en & { .fs(64,74,0); }
        }
      }
      &.body{.pt(40); .pb(114);
        img { width: calc(100% + 80px); .mh(-40); }
        .writer{.mt(90);}
        .btn-list{.wh(335,54); }
      }
    }
    .kv { .w(800);

    }
    .news{.p(100,0,120); .bgc(#f7f8fb);
      h3{.fs(34); color:#333; .tc; .mb(80);}
      [slider]{ .ib-list; .tc;
        .swiper-container{.w(1320); .mh-c;}
        .swiper-slide{.w(400); .tl; .m(0,20);
          .category{.p(22);}
          [card-image]{ .h(240);}
          .content{ .p(30,25,0,25);
            .txt{.max-h(140); overflow: hidden; .fs(16); .lh(28); .ls(-.5);}
          }
          &.img{
            .content{.h(112);
              .title{.fs(24,1.5); .ls(-1); .max-h(70);}
            }
          }
          &.text{
            .content{.h(352);
              .title{.fs(24,1.5); .ls(-1); .pr(70); height:auto; .mb(20);}
              .txt{.max-h(140);}
            }
          }
        }
      }
    }
  }
}
</style>
